/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityInfraDashboardSummaryDetails {
    getFixupPrototypeFunction() { return SecurityInfraDashboardSummaryDetails.fixupPrototype; }

    static newInstance(model: Partial<SecurityInfraDashboardSummaryDetails>): SecurityInfraDashboardSummaryDetails {
        let obj = Object.assign(new SecurityInfraDashboardSummaryDetails(), model);
        SecurityInfraDashboardSummaryDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityInfraDashboardSummaryDetails>): SecurityInfraDashboardSummaryDetails {
        if (!model) return null;
        return SecurityInfraDashboardSummaryDetails.newInstance(<SecurityInfraDashboardSummaryDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityInfraDashboardSummaryDetails) {
        if (!obj) return;

        models.SecurityInfraDashboardSummaryDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityInfraDashboardSummaryDetails): boolean {
        Object.setPrototypeOf(obj, SecurityInfraDashboardSummaryDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud Provider of the service account
     */
    cloud_provider: models.CloudServiceName;

    /**
     * ID of the service account to which the threat/vulnerability/misconfiguration belongs to.
     */
    service_account_id: string;

    /**
     * Severity values
     */
    severity: models.Severity;

    /**
     * Region the impacted resource is located in.
     */
    region: string;

    /**
     * Category of the resource to which the threat/vulnerability/misconfiguration belongs to.
     */
    resource_category: string;

    /**
     * Type of the resource to which the threat/vulnerability/misconfiguration belongs to.
     */
    resource_type: string;

    /**
     * List of Resource ID(s) where the vulnerability/threat/misconfiguration is observed.
     */
    resource_ids: Array<string>;

    /**
     * List of Unique ID(s) for vulnerability/threat/misconfiguration depending on the context.
     */
    ids: Array<string>;

}
